<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>FACULTY DETAIL</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Faculty Detail</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="">
    <div class="container">
        <div class="section-heading">
            <span class="sub-title">Information About Faculty</span>
            <h2 class="mb-9 display-16 display-sm-14 display-lg-10 font-weight-800">OUR FACULTY</h2>
            <div class="heading-seperator"><span></span></div>
        </div>

            <table class="table table-responsive table-bordered text-center">
                <thead style="background-color: #e67e22;color: white;">
                <tr>
                    <th class="bg-secondary text-white text-center" style="width: 20%;">FacultyName</th>
                    <th class="bg-secondary text-white text-center" style="width: 40%;">Department</th>
                    <th class="bg-secondary text-white text-center" style="width: 40%;">Designation</th>
                </tr>
                </thead>
                <tbody style="background: aliceblue;color:black; font-weight: bold;">
                <tr>
                    <td class=" tx-medium tx-inverse">ABHILASHA RAJPUT</td>
                    <td class=" tx-medium tx-inverse">LIFE SCIENCES</td>
                    <td class=" tx-medium tx-inverse">ACADEMIC ASSOCIATE</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">ADITI</td>
                    <td class=" tx-medium tx-inverse">RADIOLOGY (ALLIED HEALTH SCIENCES)</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">AJAY KUMAR</td>
                    <td class=" tx-medium tx-inverse">PHARMACY</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">AKHIL SHARMA</td>
                    <td class=" tx-medium tx-inverse">MLT (ALLIED HEALTH SCIENCES)</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">AMAN SHARMA</td>
                    <td class=" tx-medium tx-inverse">PHARMACY</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">AMISHA</td>
                    <td class=" tx-medium tx-inverse">PHARMACY</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">ANJNA DEVI</td>
                    <td class=" tx-medium tx-inverse">ENGLISH</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">ANKUSH KUMAR</td>
                    <td class=" tx-medium tx-inverse">PHARMACY</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">ANKUSH SHARMA</td>
                    <td class=" tx-medium tx-inverse">PHARMACY</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">ASHISH KUMAR</td>
                    <td class=" tx-medium tx-inverse">PHARMACY</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">ASHISH KUMAR</td>
                    <td class=" tx-medium tx-inverse">MECHANICAL</td>
                    <td class=" tx-medium tx-inverse">ACADEMIC ASSOCIATE</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">ASHISH PARASHAR</td>
                    <td class=" tx-medium tx-inverse">BHMCT</td>
                    <td class=" tx-medium tx-inverse">HEAD OF DEPARTMENT</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">ASMAT MUSHTAQ</td>
                    <td class=" tx-medium tx-inverse">MLT (ALLIED HEALTH SCIENCES)</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. ASHISH KUMAR SHARMA</td>
                    <td class=" tx-medium tx-inverse">MATHEMATICS</td>
                    <td class=" tx-medium tx-inverse">HEAD OF DEPARTMENT</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. GURVINDER SINGH</td>
                    <td class=" tx-medium tx-inverse">TECHNOLOGY</td>
                    <td class=" tx-medium tx-inverse">DEAN</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. MANISH KUMAR SRIVASTAVA</td>
                    <td class=" tx-medium tx-inverse">ACADEMICS</td>
                    <td class=" tx-medium tx-inverse">DEAN ACADEMIC AFFAIRS</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. NANDINI</td>
                    <td class=" tx-medium tx-inverse">PHYSIOTHERAPY (ALLIED HEALTH SCIENCES)</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. NEHA SALARIA</td>
                    <td class=" tx-medium tx-inverse">PARAMEDICAL STUDIES</td>
                    <td class=" tx-medium tx-inverse">HEAD OF DEPARTMENT</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. NEHA SHARMA</td>
                    <td class=" tx-medium tx-inverse">PHYSICAL SCIENCES</td>
                    <td class=" tx-medium tx-inverse">HEAD OF DEPARTMENT</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. POOJA GOSH</td>
                    <td class=" tx-medium tx-inverse">PHYSIOTHERAPY (ALLIED HEALTH SCIENCES)</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. RAKESH KUMAR</td>
                    <td class=" tx-medium tx-inverse">ENGLISH</td>
                    <td class=" tx-medium tx-inverse">PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. SAMIKSHA SHARMA</td>
                    <td class=" tx-medium tx-inverse">ARTS &amp; HUMANITIES</td>
                    <td class=" tx-medium tx-inverse">HEAD OF DEPARTMENT</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. SHARAD KUMAR TRIPATHI</td>
                    <td class=" tx-medium tx-inverse">LIFE SCIENCES</td>
                    <td class=" tx-medium tx-inverse">HEAD OF DEPARTMENT</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. SHREYA SINGH</td>
                    <td class=" tx-medium tx-inverse">AGRICULTURE &amp; HORTICULTURE</td>
                    <td class=" tx-medium tx-inverse">HEAD OF DEPARTMENT</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. SOM RAJ</td>
                    <td class=" tx-medium tx-inverse">ARTS &amp; HUMANITIES</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR. SUNITA</td>
                    <td class=" tx-medium tx-inverse">COMPUTER SCIENCE APPLICATION</td>
                    <td class=" tx-medium tx-inverse">HEAD OF DEPARTMENT</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">DR.NEERAJ BHANDARI</td>
                    <td class=" tx-medium tx-inverse">PHARMACY</td>
                    <td class=" tx-medium tx-inverse">PRINCIPAL</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">GEETANJALI</td>
                    <td class=" tx-medium tx-inverse">RADIOLOGY (ALLIED HEALTH SCIENCES)</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">HARJIT SINGH KAINTH</td>
                    <td class=" tx-medium tx-inverse">ELECTRONICS ENGINEERING</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">IRSHAD AHMAD SOFI</td>
                    <td class=" tx-medium tx-inverse">BUSINESS MANAGEMENT</td>
                    <td class=" tx-medium tx-inverse">HEAD OF DEPARTMENT</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">JYOTI DEVI</td>
                    <td class=" tx-medium tx-inverse">PHARMACY</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">LIPSITA MOHANTY</td>
                    <td class=" tx-medium tx-inverse">BUSINESS MANAGEMENT</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">MAJID AHMAD WANI</td>
                    <td class=" tx-medium tx-inverse">OT/AT (ALLIED HEALTH SCIENCES)</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">MANISH KUMAR</td>
                    <td class=" tx-medium tx-inverse">CHEMISTRY</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">MANJU BALA</td>
                    <td class=" tx-medium tx-inverse">MATHEMATICS</td>
                    <td class=" tx-medium tx-inverse">ACADEMIC ASSOCIATE</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">MANU MAHAJAN</td>
                    <td class=" tx-medium tx-inverse">COMMERCE</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">MEHR UN NISA</td>
                    <td class=" tx-medium tx-inverse">PARAMEDICAL STUDIES</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">MEHVISH SHOWKAT</td>
                    <td class=" tx-medium tx-inverse">LAW</td>
                    <td class=" tx-medium tx-inverse">HEAD OF DEPARTMENT</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">MINAKSHI SRIVASTAVA</td>
                    <td class=" tx-medium tx-inverse">LAW</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">MINAKSHI THAKUR</td>
                    <td class=" tx-medium tx-inverse">COMPUTER SCIENCE APPLICATION</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">MOHD. RAFIQ SHEIKH</td>
                    <td class=" tx-medium tx-inverse">COMMERCE</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">NANCY</td>
                    <td class=" tx-medium tx-inverse">ARTS &amp; HUMANITIES</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">NARENDER PAL</td>
                    <td class=" tx-medium tx-inverse">PHYSICAL EDUCATION &amp; SPORTS</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">NEHA RANI</td>
                    <td class=" tx-medium tx-inverse">COMPUTER SCIENCE ENGINEERING</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">PALLVI</td>
                    <td class=" tx-medium tx-inverse">MATHEMATICS</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">RAHUL KUMAR</td>
                    <td class=" tx-medium tx-inverse">LAW</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">RAIES AHMED THOKER</td>
                    <td class=" tx-medium tx-inverse">OT/AT (ALLIED HEALTH SCIENCES)</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">RANJNA KUMARI</td>
                    <td class=" tx-medium tx-inverse">LIFE SCIENCES</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">ROHIT KUMAR</td>
                    <td class=" tx-medium tx-inverse">CIVIL</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">ROHIT PATHANIA</td>
                    <td class=" tx-medium tx-inverse">SCHOLARSHIP</td>
                    <td class=" tx-medium tx-inverse">ACADEMIC ASSOCIATE</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SAJAN SONI</td>
                    <td class=" tx-medium tx-inverse">AGRICULTURE &amp; HORTICULTURE</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SAMIKSHA SHARMA</td>
                    <td class=" tx-medium tx-inverse">ENGLISH</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SANDEEP KUMAR</td>
                    <td class=" tx-medium tx-inverse">BHMCT</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SANJOTI</td>
                    <td class=" tx-medium tx-inverse">PHARMACY</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SAURABH SHARMA</td>
                    <td class=" tx-medium tx-inverse">CHEMISTRY</td>
                    <td class=" tx-medium tx-inverse">ACADEMIC ASSOCIATE</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SHALINI SHARMA</td>
                    <td class=" tx-medium tx-inverse">RADIOLOGY (ALLIED HEALTH SCIENCES)</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SHALLU</td>
                    <td class=" tx-medium tx-inverse">NURSING</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SHAMA RANI</td>
                    <td class=" tx-medium tx-inverse">FASHION DESIGNING</td>
                    <td class=" tx-medium tx-inverse">LECTURER</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SHASHI KAREL</td>
                    <td class=" tx-medium tx-inverse">BUSINESS MANAGEMENT</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SHAVNAM SHARMA</td>
                    <td class=" tx-medium tx-inverse">FASHION DESIGNING</td>
                    <td class=" tx-medium tx-inverse">LECTURER</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SHIVANI PATHANIA</td>
                    <td class=" tx-medium tx-inverse">PHARMACY</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SHWETA MISHRA</td>
                    <td class=" tx-medium tx-inverse">ARTS &amp; HUMANITIES</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SUKHVINDER SINGH</td>
                    <td class=" tx-medium tx-inverse">LIFE SCIENCES</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SUNITA DEVI</td>
                    <td class=" tx-medium tx-inverse">MATHEMATICS</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">SWADHIN KUMAR ROUT</td>
                    <td class=" tx-medium tx-inverse">BUSINESS MANAGEMENT</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">TAHIRA SALAM</td>
                    <td class=" tx-medium tx-inverse">OT/AT (ALLIED HEALTH SCIENCES)</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">TARUNA</td>
                    <td class=" tx-medium tx-inverse">COMPUTER SCIENCE ENGINEERING</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">UPASNA</td>
                    <td class=" tx-medium tx-inverse">AGRICULTURE &amp; HORTICULTURE</td>
                    <td class=" tx-medium tx-inverse">ASSISTANT PROFESSOR</td>
                </tr>
                <tr>
                    <td class=" tx-medium tx-inverse">YASH PAL</td>
                    <td class=" tx-medium tx-inverse">PHYSICAL SCIENCES</td>
                    <td class=" tx-medium tx-inverse">ACADEMIC ASSOCIATE</td>
                </tr>
                </tbody>
            </table>
    </div>
</section>
